module.exports = __webpack_public_path__ + "img/down-picture.7385cc25.jpg";